<template>
    <div class="draw">
        <div class="draw-l shade"
             @click="toggleDraw"
             :class="isDrawing ? 'is-active' : ''" >
            <div class="draw-l__circle"></div>
        </div>
    </div>

</template>

<script>
    export default {
        props: {
            isDrawing: {
                type: Boolean,
                default: false
            }
        },
        methods: {
          toggleDraw() {
              this.$emit('drawMode', !this.isDrawing)
          }
        }
    }
</script>

<style lang="sass" scoped>
    .draw
        width: 100%
        display: flex
        justify-content: flex-end
        margin: 16px 0
    .draw-l
        width: 60px
        height: 60px
        display: flex
        justify-content: center
        align-items: center
        z-index: 11
        transition: background .3s ease, box-shadow .3s ease
        cursor: pointer
        &:hover
            background: #F8F9FF
            box-shadow: 0px 4px 8px rgba(1, 37, 78, 0.25)
        &.is-active
            .draw-l__circle
                border-color: $color--blue
                background: rgba(44, 100, 255, 0.07)
        &__circle
            width: 32px
            height: 32px
            transition: background .3s ease, border-color .3s ease
            background: rgba(1, 37, 78, 0.07)
            border: 1px solid #01254E
            border-radius: 50%
            cursor: pointer
</style>


